import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const getCompatibilityModelGroup = createAsyncThunk('compatibility/getCompatibilityModelGroup',
  async ({ make, refresh }, { rejectWithValue }) => {
    try {
      const { data } = await authSet(METHOD_POST, '/compatibility/model', { make, group: true });
      if (data?.message) {
        return rejectWithValue(data.message);
      }
      return { data, refresh };
    } catch (error) {
      return rejectWithValue(error?.data.message);
    }
  });

export const setCompatibilityModelGroup = createAction('compatibility/setCompatibilityModelGroup');

export default getCompatibilityModelGroup;
